import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const AnalyticsBypassPage = () => {
  const navigate = useNavigate()

  useEffect(() => {
    // replace, or Back from the destination re-runs this redirect forwards in a loop
    navigate('/analytics/dashboard', { replace: true })
  }, [])
  return (
    <>
    </>
  )
}
